// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import CheckShield20 from './CheckShield20';
import CheckShield20Filled from './CheckShield20Filled';
import CheckShield20CircleFilled from './CheckShield20CircleFilled';
import CheckShield24 from './CheckShield24';
import CheckShield24Filled from './CheckShield24Filled';
import CheckShield24CircleFilled from './CheckShield24CircleFilled';
import CheckShield40 from './CheckShield40';
import CheckShield40Filled from './CheckShield40Filled';
import CheckShield48 from './CheckShield48';
import CheckShield48Filled from './CheckShield48Filled';

type CheckShieldProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    CheckShield20,
    CheckShield20Filled,
    CheckShield20CircleFilled,
    CheckShield24,
    CheckShield24Filled,
    CheckShield24CircleFilled,
    CheckShield40,
    CheckShield40Filled,
    CheckShield48,
    CheckShield48Filled,
};

const CheckShield: FC<CheckShieldProps> = ({ variation, ...props }) => {
    const variationKey = `CheckShield${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"CheckShield" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default CheckShield;
